// extracted by mini-css-extract-plugin
export default {"content":"_8e592ac10464e2e0"};